import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const Background = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 25vh;
`;

export const Message = styled.div`
  font-size: 1.5em;
  padding: 0.5em;
  color: ${COLOR.OUTER_SPACE};
`;
